/**
 * The function capitalizes the first letter of a string and replaces underscores with spaces.
 * @param s The string to capitalize.
 * @returns The capitalized string.
 */
export const capitalize = (s: string) => {
  const string = s.replace(/_/g, " ");
  return string.charAt(0).toUpperCase() + string.slice(1);
};